import { MESSAGE_SYSTEM_FAILED, MESSAGE_UNAUTHORIZED_USER } from "../constants";
import { AuthResponse, AuthResponseParsedJwt, AuthResponseParsed, AuthResponseServer } from "../models/auth";
import { AuthUserData, UserDefaultType } from "../models/user";
import { getOptions_POST, parseResponse } from "./http";

function getBody(user: UserDefaultType): AuthUserData {
    return {
        userId: user.userId || "user",
        customerName: user.firstName + ' ' + user.lastName || "user unlogged",
        accessToken: user.accessToken || "token",
        userEmail: user.emailId || "user_unlogged",
    };
}

function isAuthJwt(response: AuthResponseParsed): response is AuthResponseParsedJwt {
    return Object.keys(response).includes('jwt');
}

function getAuthMessage(response: AuthResponseServer, parsed: AuthResponseParsed): string {
    if (isAuthJwt(parsed)) return !parsed.jwt || !parsed.integrationId ? MESSAGE_UNAUTHORIZED_USER : '';

    if ([401].includes(response.status)) return MESSAGE_UNAUTHORIZED_USER;

    if ([404, 500, 501, 502, 503].includes(response.status)) return MESSAGE_SYSTEM_FAILED;

    return parsed.message;
}

export default async function getAuth(url_auth:string, user: UserDefaultType): Promise<AuthResponse> {
    try {
        console.debug(`AUTH requested...`);

        const   response: AuthResponseServer = await fetch(url_auth, getOptions_POST( getBody(user) )),
                parsed: AuthResponseParsed = await parseResponse('AUTH', response),
                displayMessage = getAuthMessage(response, parsed);

        return {
            ...parsed,
            displayMessage,
            user
        }
    } catch (error: any) {
        console.error(`Failed to retrieve AUTH data`);
        throw error;
    }
}
